export const BEST_CALL_TIME_OPTIONS = [
    { key: 'Anytime', label: 'Anytime'},
    { key: 'Morning', label: 'Morning'},
    { key: 'Afternoon', label: 'Afternoon'},
    { key: 'Evening', label: 'Evening'},
    { key: 'Weekend', label: 'Weekend'},
];

export default BEST_CALL_TIME_OPTIONS;



// WEBPACK FOOTER //
// ./app/torchmark/options/BEST_CALL_TIME_OPTIONS.js